import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, Button, XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.start.bind(this),
                'children': '开始流式回复'
            }),
            _$cc(Button, {
                'ev-click': this.reset.bind(this),
                'children': '重置'
            })
        ], 4, 'bubble-demo-xmarkdown-actions'),
        (this.get('showBubble')) ?
            _$cc(Bubble, {
                'avatar': true,
                'roleName': 'AI 助手',
                'variant': 'outlined',
                'shape': 'corner',
                'maxWidthString': '760px',
                '$blocks': function($blocks) {
                    var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                    return (
                        (
                            (_$blocks['content'] = function($super) {
                                return (
                                    _$cc(XMarkdown, {
                                        'content': this.get('content'),
                                        'streaming': this.get('streaming'),
                                        'loading': this.get('loading'),
                                        'typing': {interval: 20, step: 4}
                                    })
                                );
                            }),
                            (__$blocks['content'] = function($super, data) {
                                var block = $blocks['content'];
                                var callBlock = function() {
                                    return _$blocks['content'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            })
                        ),
                        (
                            (_$blocks['extra'] = function($super) {
                                return 'Bubble 负责承载布局，XMarkdown 负责富文本能力';
                            }),
                            (__$blocks['extra'] = function($super, data) {
                                var block = $blocks['extra'];
                                var callBlock = function() {
                                    return _$blocks['extra'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            })
                        ),
                        __$blocks
                    );
                }.call($this, _$em)
            }) :
            undefined
    ], 0, 'bubble-demo-xmarkdown');
};